var map = {
	"./icon-asfalto-b.png": 246,
	"./icon-asfalto.png": 803,
	"./icon-capinagem-b.png": 207,
	"./icon-capinagem.png": 430,
	"./icon-drenagem-de-ruas-b.png": 588,
	"./icon-drenagem-de-ruas.png": 358,
	"./icon-iluminacao-publica-b.png": 419,
	"./icon-iluminacao-publica.png": 154,
	"./icon-limpeza-urbana-b.png": 752,
	"./icon-limpeza-urbana.png": 553,
	"./icon-outros-b.png": 340,
	"./icon-outros.png": 277,
	"./icon-podagem-b.png": 87,
	"./icon-podagem.png": 470,
	"./icon-sugestao-b.png": 189,
	"./icon-sugestao.png": 120,
	"./icon-tapa-buraco-b.png": 375,
	"./icon-tapa-buraco.png": 502,
	"./icon-transito-b.png": 504,
	"./icon-transito.png": 353
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 934;